import { Icon } from 'office-ui-fabric-react';
import { DefaultButton, IconButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Checkbox } from 'office-ui-fabric-react/lib/Checkbox';
import { CommandBar } from 'office-ui-fabric-react/lib/CommandBar';
import { ConstrainMode, DetailsList, SelectionMode } from 'office-ui-fabric-react/lib/DetailsList';
import { Label } from 'office-ui-fabric-react/lib/Label';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import { ScrollablePane, ScrollbarVisibility } from 'office-ui-fabric-react/lib/ScrollablePane';
import { SearchBox } from 'office-ui-fabric-react/lib/SearchBox';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { Sticky, StickyPositionType } from 'office-ui-fabric-react/lib/Sticky';
import { TooltipHost } from 'office-ui-fabric-react/lib/Tooltip';
import React, { Component, Fragment } from 'react';
import { DataAPIParametre } from '../../data/DataAPIParametre';
import { Immocom } from '../../specifique/immocom';
import { EUIDialog } from '../EUI/EUIDialog';
import { FicheAPIParametre } from '../Fiche/FicheAPIParametre';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';

/*
**********************************************************************************************************************
PROPS :
    ATTRIBUTS :
        int?        idAPI                                   id de l'API pour laquelle afficher les paramètres
    METHODES :
        -
**********************************************************************************************************************
*/

export class DetailsListAPIParametre extends Component {

    //static defaultProps = {};

    constructor(props) {
        super(props);
        this._columns = this._getColumns();
        this._filtres = this._getFiltres();
        this._isSortedDescending = false;
        this._sortedColumn = "nomParametre";
        this._objetState = {
            items: [],
            itemActif: {},
            /* --- */
            hideMessageBarFiltres: true,
            hideMessageBarWarning: true,
            hideMessageBarError: true
        };
        this.state = { ... this._objetState };
    };

    _creationContent = () => {
        return <DetailsList
            columns={this._columns}
            constrainMode={ConstrainMode.unconstrained}
            items={this.state.items}
            onColumnHeaderClick={this._onClickColumnHeader}
            onRenderDetailsHeader={this._onRenderDetailsHeader}
            selectionMode={SelectionMode.none}
        />;
    }

    _chargementDonnees = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Chargement des paramètres en cours..."
        });

        let chargementParametres = DataAPIParametre._chargementAPIParametres(this._filtres, this._sortedColumn, this._isSortedDescending);
        chargementParametres
            .then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {
                    const listeAPIParametres = responseFetch.reponseAPIobjet || [];
                    const stateTemp = { items: listeAPIParametres };
                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
                }
                else {
                    this.setState({ items: [] });
                    Immocom.onTraitementErreurPromise(this, retourVerif);
                }
            });
    };

    _appliquerFiltres = (filtres) => {
        this._filtres = { ...this._filtres, ...filtres };
        this.setState(
            { afficherPanelFiltres: false },
            this._chargementDonnees
        );
    };

    _getColumns = () => {
        let columns = [
            {
                isSorted: true,
                isSortedDescending: true,
                key: "nomParametre",
                name: "Paramètre",
                onRender: (item) => {
                    const nomParametre = item.nomParametre;
                    return <span title={nomParametre}>{nomParametre}</span>;
                }
            },
            {
                key: "typeValeurBaliseStr",
                name: "Type",
                onRender: (item) => {
                    const typeValeurBaliseStr = item.typeValeurBaliseStr;
                    return <span title={typeValeurBaliseStr}>{typeValeurBaliseStr}</span>;
                }
            },
            {
                key: "presenceObligatoire",
                minWidth: 100,
                maxWidth: 100,
                name: "Balise obligatoire",
                onRender: (item) => {
                    return item.presenceObligatoire ? <Icon iconName="FullCircleMask" styles={{ root: { color: "green", fontSize: "1rem" } }} /> : null;
                }
            },
            {
                key: "valeurObligatoire",
                minWidth: 100,
                maxWidth: 100,
                name: "Valeur obligatoire",
                onRender: (item) => {
                    return item.valeurObligatoire ? <Icon iconName="FullCircleMask" styles={{ root: { color: "green", fontSize: "1rem" } }} /> : null;
                }
            },
            {
                key: "libelleParametre",
                name: "Libellé",
                onRender: (item) => {
                    const libelleParametre = item.libelleParametre;
                    return <span title={libelleParametre}>{libelleParametre}</span>;
                }
            },
            {
                key: "valeurParDefaut",
                name: "Valeur par défaut",
                onRender: (item) => {
                    const valeurParDefaut = item.valeurParDefaut;
                    return <span title={valeurParDefaut}>{valeurParDefaut}</span>;
                }
            },
            {
                iconName: null,
                isIconOnly: true,
                key: "edit",
                minWidth: 25,
                maxWidth: 25,
                name: "Consulter/modifier",
                onRender: (item) => {
                    return <IconButton
                        iconProps={{ iconName: "Edit" }}
                        onClick={this._togglePanelAPIParametre(true, item, false)}
                        title="Consulter/modifer ce paramètre"
                    />;
                }
            },
            //{
            //    iconName: null,
            //    isIconOnly: true,
            //    key: "delete",
            //    minWidth: 25,
            //    maxWidth: 25,
            //    name: "Supprimer",
            //    onRender: (item) => {
            //        return <IconButton
            //            iconProps={{ iconName: "Trash" }}
            //            onClick={this._toggleDialogSuppression(true, item)}
            //            title="Supprimer ce paramètre"
            //        />;
            //    }
            //},
        ];
        if (!this.props.idAPI)
            columns.unshift({
                key: "nomAPI",
                minWidth: 250,
                maxWidth: 250,
                name: "API",
                onRender: (item) => {
                    const nomAPI = item.nomAPI;
                    return <span title={nomAPI}>{nomAPI}</span>;
                }
            });
        return columns;
    };

    _getFiltres = () => {
        const { idAPI } = this.props;
        let filtres = {
            afficherParametresDontPresenceEstObligatoire: true,
            afficherParametresDontValeurEstObligatoire: true
        };
        if (idAPI) filtres.idAPI = idAPI;
        return filtres;
    };

    _getFarItems = () => {
        return [
            {
                key: "nombreEnregistrement",
                name: this.state.items.length
            },
            {
                iconOnly: true,
                iconProps: { iconName: "Filter" },
                key: "filtres",
                name: "Filtres",
                onClick: this._togglePanelFiltres(true)
            }
        ];
    };

    _getItems = () => {
        const { idAPI } = this.props;
        return [
            {
                key: "search",
                onRender: () => <SearchBox
                    className="searchBox"
                    onClear={(ev) => this._onSearch("")}
                    onSearch={(newValue) => this._onSearch(newValue)}
                    placeholder="Recherche rapide"
                />
            },
            //{
            //    key: "add",
            //    name: "Créer un paramètre",
            //    iconProps: { iconName: "Add" },
            //    onClick: this._togglePanelAPIParametre(true, { ...FicheAPIParametre.defaultProps, idAPI }, false)
            //}
        ];
    };

    _onClickColumnHeader = (ev, column) => {
        const key = column.key;
        const isSortedDescending = !(column.isSortedDescending || false)

        this._columns.forEach((col) => {
            if (col.key === key) {
                col.isSortedDescending = isSortedDescending;
                col.isSorted = true;
            } else {
                col.isSorted = false;
                col.isSortedDescending = false;
            }
        });

        this._sortedColumn = key;
        this._isSortedDescending = isSortedDescending;
        this._chargementDonnees();
    };

    _onRenderDetailsHeader = (props, defaultRender) => {
        return <Sticky stickyPosition={StickyPositionType.Header} isScrollSynced={true}>
            {defaultRender({
                ...props,
                onRenderColumnHeaderTooltip: (tooltipHostProps) => <TooltipHost {...tooltipHostProps} />
            })}
        </Sticky>
    };

    _onSearch = (keyword) => {
        this._filtres.recherche = keyword;
        this._chargementDonnees();
    };

    _supprimerParametre = () => {

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Suppression du paramètre en cours..."
        });

        const { idAPI, idParametre } = this.state.itemActif;
        let suppressionAPIParametre = DataAPIParametre._onSuppressionAPIParametre(idAPI, idParametre);
        suppressionAPIParametre
            .then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {
                    this._chargementDonnees();
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
                }
            });
        this._toggleDialogSuppression(false)();

    };

    _togglePanelAPIParametre = (isOpen, item, rechargerLesDonnees) => () => {
        this.setState(
            {
                afficherPanelAPIParametre: isOpen,
                itemActif: item || {}
            },
            rechargerLesDonnees ? this._chargementDonnees : null
        );
    };

    _togglePanelFiltres = (isOpen) => () => {
        this.setState({ afficherPanelFiltres: isOpen });
    };

    _toggleDialogSuppression = (isOpen, item) => () => {
        this.setState({
            afficherDialogSuppression: isOpen,
            itemActif: item || {}
        });
    };

    componentDidMount = () => { this._chargementDonnees(); };

    // KP - 02/01/2023 : inutile, le périmètre n'influence pas le résultat
    //componentDidUpdate = () => {
    //    if (localStorage.getItem("onRecharge") === "true") {
    //        localStorage.setItem("onRecharge", "false");
    //        this._chargementDonnees();
    //    }
    //};

    render = () => {

        const content = this._creationContent();
        const { afficherDialogSuppression, afficherPanelAPIParametre, afficherPanelFiltres, itemActif } = this.state;

        return <Fragment>

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <Stack verticalFill>
                <CommandBar
                    ariaLabel={"Utiliser les flèches droite et gauche pour naviguer"}
                    farItems={this._getFarItems()}
                    items={this._getItems()}
                    overflowButtonProps={{ ariaLabel: 'Plus de fonctionnalités' }}
                />
                <MessageBars
                    errorMessage={this.state.errorMessage}
                    infoMessage={this.state.messageMessageBarFiltres}
                    warningMessage={this.state.warningMessage}
                    onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                    onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                />
                <div className="position-relative h-100">
                    <ScrollablePane scrollbarVisibility={ScrollbarVisibility.auto}>
                        {content}
                    </ScrollablePane>
                </div>
            </Stack>

            <FicheAPIParametre
                {...itemActif}
                isOpen={afficherPanelAPIParametre}
                onDismiss={this._togglePanelAPIParametre(false, null, true)}
                onMiseAJour={this._togglePanelAPIParametre(false, null, true)}
            />

            <PanelFiltres
                filtres={{ ...this._filtres }}
                isOpen={afficherPanelFiltres}
                onValidation={this._appliquerFiltres}
                onDismiss={this._togglePanelFiltres(false)}
            />

            <EUIDialog
                buttons={[
                    <PrimaryButton key="delete" onClick={this._supprimerParametre} text="Supprimer" />,
                    <DefaultButton key="cancel" onClick={this._toggleDialogSuppression(false)} text="Annuler" />
                ]}
                isOpen={afficherDialogSuppression}
                message="Confirmez-vous la suppression de ce paramètre ?"
                onDismiss={this._toggleDialogSuppression(false)}
                titre="Suppression d'un paramètre"
            />

        </Fragment>;

    };

};

export class PanelFiltres extends Component {

    /*
    ******************************************************************************************************
    PROPS :
        ATTRIBUTS :
            object  filtres                             liste des filtres (clé/valeur)
            bool    isOpen                              détermine si panel ouvert ou non
        METHODES :
            void    onDismiss                           méthode appelée lorsque l'utilisateur clique sur "Annuler"
            void    onValidation(filtres)               méthode appelée lorsque l'utilisateur clique sur "Valider"
    ******************************************************************************************************
    */

    static defaultProps = {
        filtres: {
            afficherParametresDontPresenceEstObligatoire: true,
            afficherParametresDontValeurEstObligatoire: true
        }
    };

    constructor(props) {
        super(props);
        this.state = {};
    };

    _appliquerFiltres = () => {
        const filtres = {
            afficherParametresDontPresenceEstObligatoire: this.state.afficherParametresDontPresenceEstObligatoire,
            afficherParametresDontValeurEstObligatoire: this.state.afficherParametresDontValeurEstObligatoire,
        };
        this.props.onValidation(filtres);
    };

    _reinitialiserFiltres = () => {
        this.setState({ ...PanelFiltres.defaultProps.filtres });
    };

    _onOpen = () => {
        this.setState({
            afficherParametresDontPresenceEstObligatoire: this.props.filtres.afficherParametresDontPresenceEstObligatoire,
            afficherParametresDontValeurEstObligatoire: this.props.filtres.afficherParametresDontValeurEstObligatoire,
        });
    };

    _onRenderFooterContent = () => {
        return <Stack horizontal gap={8}>
            <PrimaryButton onClick={this._appliquerFiltres}>Valider</PrimaryButton>
            <DefaultButton onClick={this.props.onDismiss}>Fermer</DefaultButton>
        </Stack>;
    };

    render = () => {

        return <Panel
            closeButtonAriaLabel="Fermer"
            headerText="Filtres"
            isOpen={this.props.isOpen}
            onDismiss={this.props.onDismiss}
            onOpen={this._onOpen}
            onRenderFooterContent={this._onRenderFooterContent}
            type={PanelType.smallFixedFar}
        >
            <Stack>

                <Stack horizontal reversed>
                    <IconButton
                        iconProps={{ iconName: 'ClearFilter' }}
                        className="buttonFiltres"
                        title="Réinitialiser les filtres"
                        ariaLabel="Filtres"
                        onClick={this._reinitialiserFiltres}
                    />
                </Stack>

                <Checkbox
                    label="Paramètre obligatoire"
                    checked={this.state.afficherParametresDontValeurEstObligatoire}
                    onChange={(e, isChecked) => this.setState({ afficherParametresDontValeurEstObligatoire: isChecked })}
                />

                <Checkbox
                    label="Valeur obligatoire"
                    checked={this.state.afficherParametresDontPresenceEstObligatoire}
                    onChange={(e, isChecked) => this.setState({ afficherParametresDontPresenceEstObligatoire: isChecked })}
                />

            </Stack>
        </Panel>;

    };

};